<sm-title-bar pageTitle="Activity"></sm-title-bar>

<div class="row g-4">
    <div class="col-md-6">
      <sm-latest-abuse-report></sm-latest-abuse-report>
    </div>
    <div class="col-md-6">
      <sm-latest-deactivated-account></sm-latest-deactivated-account>
    </div>
</div>